import type { App } from 'vue';
import FButton from './f-button.vue';

export declare interface Button {
  install: (app: App) => void;
}

export function useButton() : Button {
  return {
    install: (app: App) => {
      app.component('FButton', FButton);
    },
  };
}